import { clearTokens } from '@creditas-lab/auth-sdk';
import {
  Menu,
  MenuGroup,
  MenuBrand,
  MenuProfile,
  ProfileOptionList,
  ProfileOptionItem,
} from '@/components/Menu';
import { dispatchLogoutEvent } from '@/utils/analyticsEvents/';
import { redirectToWebsite } from '@/utils/redirect';
import i18n from '@/i18n';
import { HeaderLinks } from './HeaderLinks';

type HeaderProps = {
  label: string;
};

const HeaderDesktop = ({ label }: HeaderProps): JSX.Element => {
  return (
    <Menu>
      <MenuGroup>
        <MenuBrand />
        <HeaderLinks />
      </MenuGroup>

      <MenuProfile label={label}>
        <ProfileOptionList>
          <ProfileOptionItem
            onClick={(): void => {
              clearTokens();
              dispatchLogoutEvent();
              redirectToWebsite();
            }}
          >
            {i18n.t('header:logout')}
          </ProfileOptionItem>
        </ProfileOptionList>
      </MenuProfile>
    </Menu>
  );
};

export { HeaderDesktop };
